import { render, staticRenderFns } from "./WInputSelect.vue?vue&type=template&id=4137a1bc&scoped=true"
import script from "./WInputSelect.vue?vue&type=script&lang=js"
export * from "./WInputSelect.vue?vue&type=script&lang=js"
import style0 from "./WInputSelect.vue?vue&type=style&index=0&id=4137a1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4137a1bc",
  null
  
)

export default component.exports